import { render, staticRenderFns } from "./incl-pharmacy-registration-codes.vue?vue&type=template&id=3ceb1918&scoped=true"
import script from "./incl-pharmacy-registration-codes.vue?vue&type=script&lang=js"
export * from "./incl-pharmacy-registration-codes.vue?vue&type=script&lang=js"
import style0 from "./incl-pharmacy-registration-codes.vue?vue&type=style&index=0&id=3ceb1918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceb1918",
  null
  
)

export default component.exports